import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { Observable } from 'rxjs';

import { Store } from '@ngrx/store';
import { IStatusPanelParams } from 'ag-grid-enterprise';

import {
  selectCostComponentSplitItemsOfSelectedSplitType,
  selectSelectedCostComponentSplitType,
  toggleSplitType as toggleSplitTypeForDetailPage,
} from '@cdba/core/store';
import {
  CostComponentSplitItem,
  CostComponentSplitType,
} from '@cdba/shared/models';

import { toggleSplitType as toggleSplitTypeForComparePage } from '../../../../../compare/store/actions';
import {
  getCostComponentSplitItems as getCostComponentSplitItemsCompare,
  getSelectedSplitType as getSelectedSplitTypeCompare,
} from '../../../../../compare/store/selectors';

@Component({
  selector: 'cdba-cost-elements-status-bar',
  templateUrl: './cost-elements-status-bar.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class CostElementsStatusBarComponent {
  private readonly store = inject(Store);

  public currentSplitType$: Observable<CostComponentSplitType>;
  public costElements$: Observable<CostComponentSplitItem[]>;

  private index: number;

  public agInit(params: IStatusPanelParams): void {
    this.index = params.context.index;

    if (this.index === undefined) {
      this.currentSplitType$ = this.store.select(
        selectSelectedCostComponentSplitType
      );
      this.costElements$ = this.store.select(
        selectCostComponentSplitItemsOfSelectedSplitType
      );
    } else {
      this.currentSplitType$ = this.store.select(
        getSelectedSplitTypeCompare({ index: this.index })
      );
      this.costElements$ = this.store.select(
        getCostComponentSplitItemsCompare({ index: this.index })
      );
    }
  }

  public toggleSelectedSplitType(): void {
    if (this.index === undefined) {
      this.store.dispatch(toggleSplitTypeForDetailPage());
    } else {
      this.store.dispatch(toggleSplitTypeForComparePage());
    }
  }
}
